import { api } from './api';

const base = '/workshop-finance';
export const workshopFinance = {
  journal: params => api.get(`${base}/journal-entries`, { params }),
  documents: params => api.get(`${base}/documents`, { params }),
  document: id => api.get(`${base}/documents/${encodeURIComponent(id)}`),
  options: () => api.get(`${base}/options`),
  create: payload => api.post(`${base}/documents`, payload),
  settle: (id, payload) => api.post(`${base}/documents/${encodeURIComponent(id)}/settlements`, payload),
  reverse: (id, payload) => api.post(`${base}/documents/${encodeURIComponent(id)}/reverse`, payload),
};
